export default [
  {
    header: "Classes",
  },
  {
    title: "Clientes",
    route: "menu-clients",
    icon: "UsersIcon",
  },
  {
    title: "Financeiro",
    route: "menu-financeiro",
    icon: "DollarSignIcon",
  },
  {
    title: "Usuários",
    route: "menu-users",
    icon: "UserIcon",
  },
  // {
  //   title: "Notificações",
  //   icon: "BellIcon",
  //   route: "forca-notifications",
  // },
  // {
  //   title: "Ajustes",
  //   icon: "SettingsIcon",
  //   route: "forca-ajustes",
  // },
];
